import styled from 'styled-components';
import ds from 'designsystem';

const DescriptionText = styled.h3`
    color: ${ds.brand('text')};
    font-size: ${ds.fs('l')};
    font-family: ${ds.get('type.fontFamily.text')};
    font-weight: ${ds.get('type.fontWeight.regular')};
`;

export default DescriptionText;



// WEBPACK FOOTER //
// ./src/elements/DescriptionText.js